import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22not-found.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./fonts/proxima-nova-regular.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22./fonts/proxima-nova-medium.woff2%22,%22weight%22:%22500%22,%22style%22:%22normal%22},{%22path%22:%22./fonts/proxima-nova-semibold.woff2%22,%22weight%22:%22600%22,%22style%22:%22normal%22},{%22path%22:%22./fonts/proxima-nova-bold.woff2%22,%22weight%22:%22700%22,%22style%22:%22normal%22}],%22display%22:%22swap%22,%22variable%22:%22--mw-font-family%22}],%22variableName%22:%22proximaNova%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'proximaNova', 'proximaNova Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
